import { configureStore } from '@reduxjs/toolkit';
import { IFullState } from '../types/All.type';
import GenesisUserRolePermission from './reducers/GenesisUser';
import Theme from './Theme';
import Toggle from './reducers/Toggle';
import Locations from './reducers/Locations';
import ActivityMaintence from './reducers/Activities';
import Counterparty from './reducers/Counterparty';
import Units from './reducers/Unit';
import Nominations from './reducers/Nominations';
import AdjacentTSO from './reducers/AdjacentTSO';
import Audit from './reducers/AuditLogs';
import SwingContract from './reducers/SwingContract';
import BeachSwingAndTrades from './reducers/BeachSwingAndTrades';
import SwingNomsByContract from './reducers/SwingNomsByContract';
import ProducerConfig from './reducers/ProducerConfig';
import Dashboard from './reducers/Dashboard';
import Notifications from './Notifications';
import ShipperActuals from './reducers/ShipperActuals';
import ProducerDeliveries from './reducers/ProducerDeliveries';
import Tradings from './reducers/Trading';
import BeachChecks from './reducers/BeachChecks';
import CounterpartyStatementsConfig from './reducers/CounterpartyStatementsConfig';
import Automation from './reducers/AutomationConfiguration';
import CounterpartyStatementsDetails from './reducers/CounterpartyStatements';

const store = configureStore<IFullState>({
  reducer: {
    Notifications,
    Theme,
    Toggle,
    genesisUserRolePermission: GenesisUserRolePermission,
    Locations,
    Counterparty,
    ActivityMaintence,
    Units,
    Nominations,
    AdjacentTSO,
    Audit,
    SwingContract,
    BeachSwingAndTrades,
    SwingNomsByContract,
    Dashboard,
    ProducerConfig,
    ShipperActuals,
    ProducerDeliveries,
    Tradings,
    BeachChecks,
    CounterpartyStatementsConfig,
    Automation,
    CounterpartyStatementsDetails,
  },
});

export type AppDispatch = typeof store.dispatch;
export default store;
